import { StdResponse, bimAxios } from "@/config/axios";
import { RsProjectGlobalCable } from "@/commons/interface/project-device/project-cable";

export function getProjectCables(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/project-global-cables`, {
        params: {
            ...params,
        }
    })
}

export function createProjectGCables(data: RsProjectGlobalCable[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/project-global-cables`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectGCable(projectUuid: string, globalCableId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/project-global-cables/delete`, {
        params: {
            ...params,
            projectUuid: projectUuid,
            globalCableId: globalCableId,
        }
    })
}   